import React from 'react'
import DateFnsUtils from "@date-io/date-fns";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import {
  FNS_FOLLOWUP_DATE_FORMAT,
  FOLLOW_UP_FILTER_FORMAT
} from "../../../util/constants";
import { getPageFilters } from "../../../util/helpers";
import * as auth from "../../Auth/_redux/authRedux";

export default function DatePickerCRM(props) {
  const [uiState, setUiState] = useState(
    props.initialOpen ? "opened" : "closed"
  );
  const [startDate, setStartDate] = useState(
    new Date(moment(new Date()).startOf("day"))
  );
  const [endDate, setEndDate] = useState(new Date());
  const listKey = props.filter_key;
  const dispatch = useDispatch();

  const updateDateRedux = (e, key) => {
    let pageFilters = getPageFilters(); //ch1
    pageFilters = { ...pageFilters };
    pageFilters[listKey] = [
      moment(key === "setStartDate" ? e : startDate).format(
        FOLLOW_UP_FILTER_FORMAT
      ),
      moment(key === "setEndDate" ? e : endDate).format(
        FOLLOW_UP_FILTER_FORMAT
      ),
    ];

    var changelog = {};
    changelog[listKey] = [
      moment(key === "setStartDate" ? e : startDate).format(
        FOLLOW_UP_FILTER_FORMAT
      ),
      moment(key === "setEndDate" ? e : endDate).format(
        FOLLOW_UP_FILTER_FORMAT
      ),
    ];
    pageFilters["changelog"] = changelog;

    const action = {
      type: auth.actionTypes.Set,
      payload: { ...pageFilters },
    };
    dispatch(action);
    dispatch(
      auth.actions.CheckFiltersState({
        apply: true,
        filter_type: props.filterState ? props.filterState : "crmFiltersState",
      })
    );
  };

  const { followUpDatePickerModalState } = props;

  const handleChange = (e, key) => {
    if (key === "setStartDate") {
      setStartDate(e);
    } else {
      setEndDate(e);
    }
    updateDateRedux(e, key);
  };

  useEffect(() => {
    setStartDate(new Date(moment(new Date()).startOf("day")));
    setEndDate(new Date());
    setUiState("closed");
  }, [props.clearFilterFlag]);

  const renderInput = (props) => {
    return (
      <div className="position-relative customer-management-input-date-range">
        <img
          alt=""
          src={toAbsoluteUrl("/media/sr/icons/crm/calendar-icon.svg")}
          className="calendar-icon"
          style={{
            position: "absolute",
            zIndex: "2",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            height: "20px",
          }}
        ></img>
        <input
          className=""
          type="text"
          onClick={props.onClick}
          defaultValue={props.value}
          onChange={props.onChange}
        />
      </div>
    );
  };

  return (
    <ul className="list-unstyled p-5 mb-0">
      <li className="title mt-1">
        {uiState === "opened" && (
          <span className="mr-3">
            <img
              alt=""
              onClick={() => {
                setUiState("closed");
              }}
              src={toAbsoluteUrl("/media/sr/icons/filter-minus.svg")}
            />
          </span>
        )}
        {uiState === "closed" && (
          <span className="mr-3">
            <img
              alt=""
              onClick={() => {
                setUiState("opened");
              }}
              src={toAbsoluteUrl("/media/sr/icons/filter-plus.svg")}
            />
          </span>
        )}
        <span className="sub-filter-title">{props.filter_title}</span>
      </li>
      {uiState === "opened" && (
        <li>
          <div className="mt-2">
            <div className="d-flex flex-column justify-content-start">
              <span className="mt-3">FROM</span>
              <div className="mt-2">
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  libInstance={moment}
                >
                  <DateTimePicker
                    format={FNS_FOLLOWUP_DATE_FORMAT}
                    inputVariant="outlined"
                    label="From Date"
                    value={startDate}
                    onChange={(e) => handleChange(e, "setStartDate")}
                    TextFieldComponent={renderInput}
                    maxDate={new Date()}
                    // autoOk={true}
                    onClose={() => {
                      followUpDatePickerModalState(false);
                    }}
                    onOpen={() => {
                      followUpDatePickerModalState(true);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <span className="mt-3">TO</span>
              <div className="mt-2">
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  libInstance={moment}
                >
                  <DateTimePicker
                    format={FNS_FOLLOWUP_DATE_FORMAT}
                    inputVariant="outlined"
                    label="To Date"
                    value={endDate}
                    onChange={(e) => handleChange(e, "setEndDate")}
                    TextFieldComponent={renderInput}
                    minDate={startDate}
                    onClose={() => followUpDatePickerModalState(false)}
                    onOpen={() => followUpDatePickerModalState(true)}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          </div>
        </li>
      )}
    </ul>
  );
}
